import React from 'react';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// nodejs library that concatenates classes
import classNames from 'classnames';

import { Autocomplete, FormControl, FormHelperText, TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import SkeletonWrapper from 'Components/SkeletonWrapper';

const useStyles = makeStyles(theme => ({
  fixLabel: {
    '& label': {
      left: '0',
      top: '5px',
    },
  },
  labelRootError: {
    color: 'red !important',
  },
}));

export default function CustomAutocomplete({
  formControlProps,
  options,
  labelText,
  disabled,
  id,
  autocompleteClasses,
  autocompleteProps,
  error,
  success,
  helperText,
  hasSkeleton,
  skeletonAnimation,
  skeletonVariant,
  skeletonProps,
  isLoading,
}) {
  const classes = useStyles();

  var formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = classNames(formControlProps.className, classes.formControl);
  } else {
    formControlClasses = classes.formControl;
  }

  var helpTextClasses = classNames({
    [classes.labelRootError]: error,
    [classes.labelRootSuccess]: success && !error,
  });

  if (hasSkeleton && isLoading) {
    return (
      <SkeletonWrapper
        animation={skeletonAnimation}
        variant={skeletonVariant}
        skeletonProps={skeletonProps}
        fullWidth={formControlProps?.fullWidth}
        isLoading
        component={
          <FormControl {...formControlProps} className={`${formControlClasses} ${classes.selectFormControl}`}>
            <Autocomplete
              className={classes.fixLabel}
              options={[]}
              renderInput={params => <TextField {...params} label={labelText} variant="standard" />}
            />
          </FormControl>
        }
      />
    );
  }

  return (
    <FormControl {...formControlProps} className={`${formControlClasses} ${classes.selectFormControl}`}>
      <Autocomplete
        className={`${classes.fixLabel} ${autocompleteClasses}`}
        options={options}
        renderInput={params => <TextField error={error} {...params} label={labelText} variant="standard" />}
        disabled={disabled}
        {...autocompleteProps}
      />
      {helperText && (
        <FormHelperText id={id + '-text'} className={helpTextClasses}>
          {helperText}
        </FormHelperText>
      )}

      {error && (
        <FormHelperText id={id + '-error'} className={helpTextClasses}>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
}

CustomAutocomplete.propTypes = {
  formControlProps: PropTypes.object,
  options: PropTypes.array,
  labelText: PropTypes.string,
  id: PropTypes.string,
  autocompleteProps: PropTypes.object,
  autocompleteClasses: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  success: PropTypes.bool,
  helperText: PropTypes.string,
  hasSkeleton: PropTypes.bool,
  skeletonAnimation: PropTypes.string,
  skeletonVariant: PropTypes.string,
  skeletonProps: PropTypes.object,
  isLoading: PropTypes.bool,
};
